import { ONBOARDING_LOADING_VARIANT } from '@/composables/onboarding-ai-step'

export const DEFAULT_TASK_INTERVAL_MS = 3000

export const ONBOARDING_AI_FAILED_REDIRECT_DELAY_MS = 4000

export const ONBOARDING_AI_LOADING_STEP_VARIANT_CONFIG = {
  [ONBOARDING_LOADING_VARIANT.COMPANY_SIZE]: {
    tasks: [
      'onboarding.ai.company_size_loading.task_homepage',
      'onboarding.ai.company_size_loading.task_profile',
      'onboarding.ai.company_size_loading.task_size'
    ],
    titleKeypath: 'onboarding.ai.company_size_loading.title_prefix',
    titleAccentKey: 'onboarding.ai.company_size_loading.title_accent',
    subtitleKey: 'onboarding.ai.company_size_loading.subtitle',
    taskIntervalMs: 1500
  },
  [ONBOARDING_LOADING_VARIANT.RESEARCH]: {
    tasks: [
      'onboarding.ai.research_loading.task_homepage',
      'onboarding.ai.research_loading.task_profile',
      'onboarding.ai.research_loading.task_industry',
      'onboarding.ai.research_loading.task_size',
      'onboarding.ai.research_loading.task_summary'
    ],
    titleKeypath: 'onboarding.ai.research_loading.title_prefix',
    titleAccentKey: 'app_name',
    subtitleKey: 'onboarding.ai.research_loading.subtitle',
    taskIntervalMs: DEFAULT_TASK_INTERVAL_MS
  },
  [ONBOARDING_LOADING_VARIANT.SETUP]: {
    tasks: [
      'onboarding.ai.setup_loading.task_objectives',
      'onboarding.ai.setup_loading.task_key_results',
      'onboarding.ai.setup_loading.task_outcomes',
      'onboarding.ai.setup_loading.task_ambition',
      'onboarding.ai.setup_loading.task_kpis'
    ],
    titleKeypath: 'onboarding.ai.setup_loading.title_prefix',
    titleAccentKey: 'onboarding.ai.setup_loading.title_accent',
    subtitleKey: null,
    taskIntervalMs: DEFAULT_TASK_INTERVAL_MS
  }
}

export const getOnboardingAiLoadingStepVariantConfig = variant =>
  ONBOARDING_AI_LOADING_STEP_VARIANT_CONFIG[variant] ?? null

export const resolveTaskIntervalMs = (variantConfig, defaultMs = DEFAULT_TASK_INTERVAL_MS) =>
  variantConfig?.taskIntervalMs ?? defaultMs

export const getLoadingStepTaskIconName = ({ taskIndex, activeTaskIndex, taskCount }) => {
  if (taskIndex < activeTaskIndex) {
    return 'checkmark-ready'
  }

  if (taskIndex === activeTaskIndex && activeTaskIndex < taskCount) {
    return 'logo-loader'
  }

  return 'checkmark-empty'
}
